<template>
  <v-main>
    <v-container>
      <v-layout column wrap align-content-center justify-center>
        <v-card :width="640" :elevation="3" class="ma-3">
          <v-window v-model="formModel" touchless>
            <v-window-item>
              <v-toolbar color="error" dark flat>
                <v-toolbar-title> Delete account </v-toolbar-title>
              </v-toolbar>
              <v-form>
                <v-card-text>
                  <div class="mb-3">
                    Enter your password to confirm deletion.
                  </div>
                  <v-alert
                    v-if="error"
                    border="bottom"
                    colored-border
                    type="error"
                    rounded="0"
                  >
                    {{ error }}
                  </v-alert>
                  <v-text-field
                    v-model="v$.password.$model"
                    label="Password"
                    :append-icon="
                      showPassword ? 'visibility' : 'visibility_off'
                    "
                    :type="showPassword ? 'text' : 'password'"
                    :error-messages="errors"
                    color="accent"
                    loader-height="3"
                    counter
                    filled
                    :loading="showLoading"
                    :disabled="showLoading"
                    @click:append="showPassword = !showPassword"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text :disabled="showLoading" @click="$router.back()">
                    Not now
                  </v-btn>
                  <v-btn
                    depressed
                    type="submit"
                    :disabled="v$.$invalid || showLoading"
                    color="error"
                    @click.prevent="deleteAccount()"
                  >
                    Delete permanently
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-window-item>
            <v-window-item>
              <v-alert
                border="top"
                color="primary"
                colored-border
                prominent
                type="success"
                class="mb-0"
              >
                <v-card-title>Account deleted</v-card-title>
                <v-card-subtitle>
                  Your account has been deleted and will not receive
                  notifications of your subscriptions.
                </v-card-subtitle>
                <v-card-actions>
                  <v-btn color="accent" text :to="{ path: '/' }">home</v-btn>
                </v-card-actions>
              </v-alert>
            </v-window-item>
          </v-window>
        </v-card>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { minLength, required } from "@vuelidate/validators";
import { AxiosError, HttpStatusCode } from "axios";

export default {
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      showPassword: false,
      accountDeleted: false,
      password: undefined,
      error: undefined,
      showLoading: false,
      formModel: 0,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    errors() {
      return this.v$.$errors.map((e) => e.$message);
    },
  },
  validations() {
    return {
      password: { required, minLength: minLength(8) },
    };
  },
  methods: {
    async deleteAccount() {
      try {
        this.showLoading = true;
        this.accountDeleted = false;
        this.error = undefined;

        try {
          await this.$store.state.axios.post("api/auth/login", {
            email: this.user.email,
            password: this.password,
          });
        } catch (e) {
          throw new AxiosError(
            "Sorry, we couldn't verify your identify.",
            HttpStatusCode.Unauthorized
          );
        }

        await this.$store.state.axios.delete(
          `api/passenger/${this.user.cnxUserId}`
        );
        await this.$store.state.axios.delete(`api/auth/${this.user.cnxUserId}`);

        await this.$store.state.axios.post("api/auth/logout");
        this.$store.commit("logout");

        this.accountDeleted = true;
        this.formModel = 1;
      } catch (e) {
        if (e instanceof AxiosError && e.code === HttpStatusCode.Unauthorized) {
          this.error = e.message;
        } else {
          this.error =
            "Sorry, we couldn't delete your account due to an error happened.";
        }
      } finally {
        this.showLoading = false;
        this.password = undefined;
        this.v$.$reset();
      }
    },
  },
};
</script>
